import sidebarLogo from './logo-sidebar.svg';

/**
 * The full logo for DevHub.
 * @param height - The height of the logo.
 * @constructor
 */
const LogoFull = ({ height = '40px' }: { height: string }) => {
  return <img src={sidebarLogo} height={height} alt="DevHub" />;
};

export default LogoFull;
